import { CellSelection } from '../../../../../common/table/TableTypes';
import { getEndCol, getEndRow, getStartCol, getStartRow } from './tableSelectionAccessors';
import { getNColsInSelection, getNRowsInSelection } from './tableSelectionCountUtils';
import { isSelectingRefColHeader, isSelectingRefRowHeader } from './tableSelectionPredicateUtils';

/**
 * Moves a selection to the next column span on the right.
 */
export const moveCellsRight = (selection: CellSelection): CellSelection => {
    const numberOfCols = getNColsInSelection(selection);

    if (isSelectingRefRowHeader(selection))
        return [getStartRow(selection), getEndCol(selection) + 1, getEndRow(selection), getEndCol(selection) + 1];

    return [
        getStartRow(selection),
        getStartCol(selection) + numberOfCols,
        getEndRow(selection),
        getEndCol(selection) + numberOfCols,
    ];
};

/**
 * Moves a selection to the previous column span on the left.
 */
export const moveCellsLeft = (selection: CellSelection): CellSelection => {
    const numberOfCols = getNColsInSelection(selection) - 2;

    return [
        getStartRow(selection),
        getStartCol(selection) + numberOfCols,
        getEndRow(selection),
        getEndCol(selection) + numberOfCols,
    ];
};

/**
 * Moves a selection to the next row span below.
 */
export const moveCellsDown = (selection: CellSelection): CellSelection => {
    const numberOfRows = getNRowsInSelection(selection);

    if (isSelectingRefColHeader(selection))
        return [getEndRow(selection) + 1, getStartCol(selection), getEndRow(selection) + 1, getEndCol(selection)];

    return [
        getStartRow(selection) + numberOfRows,
        getStartCol(selection),
        getEndRow(selection) + numberOfRows,
        getEndCol(selection),
    ];
};

/**
 *  Moves a selection to the previous row span above.
 */
export const moveCellsUp = (selection: CellSelection): CellSelection => {
    const numberOfRows = getNRowsInSelection(selection) - 2;

    return [
        getStartRow(selection) + numberOfRows,
        getStartCol(selection),
        getEndRow(selection) + numberOfRows,
        getEndCol(selection),
    ];
};
